import type { ReactNode } from "react";

export function StickyFooter({ children }: { children: ReactNode }) {
  return <div className="sticky-footer">{children}</div>;
}
